import { Clock, Calendar } from "lucide-react";
import { useState } from "react";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { HorariosTab } from "../features/horarios";
import AgendamentosConfig from "./AgendamentosConfig";

/**
 * Configurações → Horários (v1.5.466): a tela ganhou duas abas — os horários
 * de funcionamento (conteúdo original, intocado) e a configuração de
 * AGENDAMENTOS, movida de Impulsione suas Vendas a pedido do dono: agendar
 * pedido é uma regra de QUANDO a loja atende, então mora junto dos horários.
 * A rota antiga (/impulsione/agendamentos) continua funcionando e cai na aba.
 * 25/10/2026: a aba Horários foi repaginada e mora em features/horarios.
 */
export default function ConfiguracaoHorarios({ defaultTab = "horarios" }) {
  const [tab, setTab] = useState(defaultTab);
  return (
    <div className="w-full">
      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <div className="px-4 sm:px-6 pt-4 overflow-x-auto">
          <TabsList className="inline-flex h-11 gap-1 rounded-full bg-muted/60 p-1 shadow-sm border border-border/50">
            <TabsTrigger value="horarios" className="rounded-full px-4 data-[state=active]:bg-background">
              <Clock className="w-4 h-4 mr-1.5" /> Horários
            </TabsTrigger>
            <TabsTrigger value="agendamentos" className="rounded-full px-4 data-[state=active]:bg-background">
              <Calendar className="w-4 h-4 mr-1.5" /> Agendamentos
            </TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="horarios" className="mt-0">
          <HorariosTab />
        </TabsContent>
        <TabsContent value="agendamentos" className="mt-0">
          <AgendamentosConfig />
        </TabsContent>
      </Tabs>
    </div>
  );
}
